export enum TransactionTypeCode {
  ORDER_NEW = 'ORDER_NEW',
  ORDER_NEW_ZERO_VALUE = 'ORDER_NEW_ZERO_VALUE',
  ORDER_UPSELL = 'ORDER_UPSELL',
  ORDER_RESTRUCTURE = 'ORDER_RESTRUCTURE',
  ORDER_RESTRUCTURE_UPGRADE = 'ORDER_RESTRUCTURE_UPGRADE',
  ORDER_RESTRUCTURE_DOWNSELL = 'ORDER_RESTRUCTURE_DOWNSELL',
  ORDER_RESTRUCTURE_SUNSET = 'ORDER_RESTRUCTURE_SUNSET',
  ORDER_RESTRUCTURE_CONVERSION = 'ORDER_RESTRUCTURE_CONVERSION',
  TDD_ORDER_NEW = 'TDD_ORDER_NEW',
  TDD_ORDER_NEW_ZERO_VALUE = 'TDD_ORDER_NEW_ZERO_VALUE',
  TDD_UPSELL = 'TDD_UPSELL',
  TDD_EXTENSION = 'TDD_EXTENSION',
  EXTENSION_CONTACT_SUPPORT = 'EXTENSION_CONTACT_SUPPORT',

  LEAD_BUY = 'LEAD_BUY',
  LEAD_RFI = 'LEAD_RFI',
  LEAD_TRIAL = 'LEAD_TRIAL',
  VIEW_PRICING = 'VIEW_PRICING',

  MANAGE_ORDERS = 'MANAGE_ORDERS',
  ORDER_EXTENSION = 'ORDER_EXTENSION',
  CONTACT_SUPPORT = 'CONTACT_SUPPORT',
  CONTACT_SALES_REP = 'CONTACT_SALES_REP',
  UPSELL_CONTACT_SALES_REP = 'UPSELL_CONTACT_SALES_REP',
  UPSELL_CONTACT_SUPPORT = 'UPSELL_CONTACT_SUPPORT',
  UPSELL_CONTACT_PARTNER = 'UPSELL_CONTACT_PARTNER',

}
